import editNode from './edit-node';

const editLink = editNode;
editLink.useRangeRect = false;

export default editLink;